import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import { createLinkToView } from 'Common/utils';
import { route } from 'VariantView/routes';
import ArrowLink from '../ArrowLink/ArrowLink';
const BaseLink = createLinkToView(route, ArrowLink);
const LinkToVariantView = ({ routeParams, referrerData, label, title, handleClick, }) => {
    if (!FEATURE_FLAGS.VLR_TAB_ENABLED) {
        return _jsx(_Fragment, { children: label }, void 0);
    }
    return (_jsx(BaseLink, { routeParams: routeParams, referrerData: referrerData, label: label, title: title, handleClick: handleClick }, void 0));
};
export default memo(LinkToVariantView);
